import React from 'react'
import { Route } from 'react-router-dom'
import { LoginAccount } from './page/login-account'
import { Invitations } from './page/invitations'
import { LoginEmail } from './page/login-email'
import { LoginError } from './page/login-error'
import { LoginProviders } from './page/login-provider'
import { PasswordRequest } from './page/password-request'
import { PasswordResult } from './page/password-result'
import { PasswordReset } from './page/password-reset'
import { Register } from './page/register'

export function LayoutUnAuthorized() {
  return (
    <React.Fragment>
      <Route path="/auth/email" component={LoginEmail} />
      <Route path="/auth/providers" component={LoginProviders} />
      <Route path="/auth/account" component={LoginAccount} />
      <Route path="/auth/invitations" component={Invitations} />
      <Route path="/auth/error" component={LoginError} />
      <Route path="/auth/register" component={Register} />

      <Route path="/auth/password-recover/request" component={PasswordRequest} />
      <Route path="/auth/password-recover/result/:email" component={PasswordResult} />
      <Route path="/auth/password-recover/reset/:resetToken" component={PasswordReset} />
    </React.Fragment>
  )
}
